const Images = [
    {
        ID: 3,
        img: require('./3.jpg'),
    },
];

export default Images;
